<template>
    <div class="flex">
       <input
          type="text"
          class="text-2xl font-bold pl-2 rounded-md
                h-10 w-full bg-transparent
                hover:ease-in hover:duration-100
                hover:bg-gray-200 overflow-hidden
                block text-ellipsis whitespace-nowrap
          "
          v-model="label"
        >
    </div>
</template>

<script setup>
import { defineModel} from "vue";

const label = defineModel()


</script>